import {
    Box,
    Button,
    Link,
    Typography,
} from '@mui/material'
import {Image} from 'antd'
import Banner1 from '../../assets/product-service/product-banner1.png'
import Banner2 from '../../assets/product-service/product-banner2.png'
import Banner3 from '../../assets/product-service/product-banner3.png'
import Banner4 from '../../assets/product-service/product-banner4.png'
import Banner5 from '../../assets/product-service/product-banner5.png'
import CheckIcon from '../../assets/product-service/product-icon.png'
import { ROOT_PATH } from '../../common/config'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMProductIntroduce: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'imageUrl': Banner1,
            'title': t('t119'),
            'content': t('t120'),
            'data': [
                t('t121'),
                t('t122'),
                t('t123'),
                t('t124'),
            ],
            'buttonTitle': t('t125'),
            'link': ROOT_PATH + '/motorcycle-financing'
        },
        {
            'imageUrl': Banner2,
            'title': t('t126'),
            'content': t('t127'),
            'data': [
                t('t128'),
                t('t129'),
                t('t130'),
                t('t131'),
                t('t132'),
            ],
            'buttonTitle': t('t125'),
            'link': ROOT_PATH + '/personal-loan'
        },
        {
            'imageUrl': Banner3,
            'title': t('t133'),
            'content': t('t134'),
            'data': [
                t('t135'),
                t('t136'),
                t('t137'),
            ],
            'buttonTitle': t('t125'),
            'link': ROOT_PATH + '/motor-vehicle'
        },
        {
            'imageUrl': Banner4,
            'title': t('t138'),
            'content': t('t139'),
            'data': [
                t('t140'),
                t('t141'),
                t('t142'),
                t('t143'),
                t('t144'),
                t('t145'),
                t('t146'),
                t('t147'),
            ],
            'buttonTitle': t('t125'),
            'link': ROOT_PATH + '/mobile-app'
        },
        {
            'imageUrl': Banner5,
            'title': t('t148'),
            'content': t('t149'),
            'data': [
                t('t150'),
                t('t151'),
                t('t152'),
                t('t153'),
                t('t154'),
                t('t155'),
                t('t156'),
                t('t157'),
                t('t158'),
            ],
            'buttonTitle': t('t159'),
            'link': ROOT_PATH + '/repayment-channel'
        }
    ]

    const renderLeftItem = (index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: isTablet ? '40px' : '72px',
                paddingRight: isTablet ? '40px' : '72px',
                paddingTop: '60px',
                paddingBottom: '60px',
            }}>
                <Image src={data[index]['imageUrl']} width={isTablet ? 460 : 556} height={isTablet ? 430 : 520} style={{borderRadius: '10px'}} alt='' preview={false}></Image>

                <Box sx={{
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingLeft: isTablet ? '30px' : '80px',
                }}>
                    <Typography fontWeight={700} fontSize={32} color={'#141F39'}>
                        {data[index]['title']}
                    </Typography>

                    <Typography fontWeight={400} fontSize={16} color={'#6B6B6B'} paddingTop={'16px'}>
                        {data[index]['content']}
                    </Typography>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: isTablet ? '20px' : '48px',
                    }}>
                        {data[index]['data'].map((value, subiIndex) => (
                            renderTitleItem(value, subiIndex)
                        ))}
                    </Box>

                    <Box sx={{
                        paddingTop: isTablet ? '0px' : '26px'
                    }}>
                        <Link href={data[index]['link']}>
                            <Button
                                variant='contained'
                                sx={{
                                    borderRadius: '30px',
                                    mt: 6,
                                    bgcolor: '#FFC107',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    height: '60px',
                                    paddingLeft: '50px',
                                    paddingRight: '50px',
                                    textTransform: 'none'
                                }}
                            >
                                {data[index]['buttonTitle']}
                            </Button>
                        </Link>
                    </Box>
                </Box>
            </Box>
        )
    }

    const renderRightItem = (index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingLeft: '72px',
                paddingRight: '72px',
                paddingTop: '60px',
                paddingBottom: '60px',
            }}>
                <Box sx={{
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    paddingRight: '80px',
                }}>
                    <Typography fontWeight={700} fontSize={32} color={'#141F39'}>
                        {data[index]['title']}
                    </Typography>

                    <Typography fontWeight={400} fontSize={16} color={'#6B6B6B'} paddingTop={'16px'}>
                        {data[index]['content']}
                    </Typography>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        paddingTop: isTablet ? '20px' : '48px',
                    }}>
                        {data[index]['data'].map((value, subIndex) => (
                            renderTitleItem(value, subIndex)
                        ))}
                    </Box>

                    <Box sx={{
                        paddingTop: isTablet ? '0px' : '26px'
                    }}>
                        <Link href={data[index]['link']}>
                            <Button
                                variant='contained'
                                sx={{
                                    borderRadius: '30px',
                                    mt: 6,
                                    bgcolor: '#FFC107',
                                    color: '#141F39',
                                    '&:hover': {
                                        bgcolor: '#FFC107',
                                    },
                                    height: '60px',
                                    paddingLeft: '50px',
                                    paddingRight: '50px',
                                    textTransform: 'none'
                                }}
                            >
                                {data[index]['buttonTitle']}
                            </Button>
                        </Link>
                    </Box>
                </Box>

                <Image src={data[index]['imageUrl']} width={isTablet ? 460 : 556} height={isTablet ? 430 : 520} style={{borderRadius: '10px'}} alt='' preview={false}></Image>
            </Box>
        )
    }

    const renderTitleItem = (value: string, index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingBottom: '12px',
            }}>
                <Image src={CheckIcon} width={20} height={20} alt='' preview={false}></Image>
                <Typography fontSize={16} fontWeight={500} color={'#141F39'} paddingLeft={'15px'}>
                    {value}
                </Typography>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
            }}
        >
            {data.map((item, index) => (
                (index % 2 === 0) ? renderLeftItem(index) : renderRightItem(index)
            ))}
        </Box>
    )
}

// ======================= EXPORT
export default SMProductIntroduce
